import { render } from "./TopBarWhiteBackgroundPatients.vue?vue&type=template&id=d124a4b6&scoped=true"
import script from "./TopBarWhiteBackgroundPatients.vue?vue&type=script&lang=js"
export * from "./TopBarWhiteBackgroundPatients.vue?vue&type=script&lang=js"

import "./TopBarWhiteBackgroundPatients.vue?vue&type=style&index=0&id=d124a4b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d124a4b6"]])

export default __exports__